import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/print-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-618b0d46"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "header-content",
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "thoughttoss", -1))
const _hoisted_3 = { class: "menu-buttons" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "B", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "I", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "U", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "btn-theme-mode__white" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "btn-theme-mode__switch" }, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["Header", [_ctx.theme, _ctx.themeColor]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          id: "btn-bold",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.textCommand('bold')))
        }, _hoisted_5),
        _createElementVNode("button", {
          id: "btn-italic",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.textCommand('italic')))
        }, _hoisted_7),
        _createElementVNode("button", {
          id: "btn-underline",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.textCommand('underline')))
        }, _hoisted_9),
        _hoisted_10,
        _createElementVNode("button", {
          id: "btn-theme-mode",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChangeMode && _ctx.handleChangeMode(...args)))
        }, _hoisted_13),
        _createElementVNode("button", {
          id: "btn-theme-color",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleChangeColor && _ctx.handleChangeColor(...args)))
        }),
        _hoisted_14,
        _createElementVNode("button", {
          id: "btn-print",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.printPage && _ctx.printPage(...args)))
        }, _hoisted_16)
      ])
    ])
  ], 2))
}